import "./Post.css";
import { BiLike } from "react-icons/bi";
import { BiCommentDots } from "react-icons/bi";
import { MdDelete } from 'react-icons/md';
import { useState, useContext, useEffect } from "react";
import { Link } from 'react-router-dom'
import timeAgo from "./timeAgo";
import AuthContext from "../../../context/AuthProvider";
import { axiosInstance } from "../../../config.util";

export default function Post({post}) {
    const [like, setLike] = useState(post.likes.length);
    const [isLiked, setIsLiked] = useState(false);
    const [postUserName, setPostUserName] = useState([]);
    const {authState: user} = useContext(AuthContext)

    // console.log('From post:', user);

    const likeIncrHandler = ()=>{
        try {
            axiosInstance.put(`posts/${post._id}/like`,{userId: user.id}, {headers: {authorization: 'Bearer '+user.accessToken}})
        } catch (error) {
            
        }
        setLike(isLiked ? like-1 : like+1)
        setIsLiked(!isLiked)
    }
    const clickPostDelete = async ()=>{
        try {
            // console.log('this post id:',post._id, user.id);
            // await axios.delete(`posts/${post._id}`, {userId: user.id}, {headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer '+user.accessToken}})
            // await axios.delete(`posts/${post._id}`, {data: {userId: user.id}}, {headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer '+user.accessToken}})
            // await axios.delete(`posts/${post._id}`, {headers: {authorization: 'Bearer '+user.accessToken}}, {data: {userId: user.id}})
            // await axios.delete(`posts/${post._id}`, {headers: {authorization: 'Bearer '+user.accessToken}}, {userId: user.id})
            await axiosInstance.delete(`posts/${post._id}`,{data: {userId: user.id}})
            // await axios.delete(`posts/${post._id}`, {data: {userId: user.id}}, {headers: {authorization: 'Bearer '+user.accessToken}})
            .then((res)=>{
                window.location.reload()
                // console.log('Deleted', res.data.json);
            }).catch((err)=>{
                console.log("report to developer");
                // console.log('UNABLE to delete');
            })
        } catch (error) {
            console.log('Not possible');   
        }
    }

    useEffect(()=>{
        setIsLiked(post.likes.includes(user.id))
    }, [user.id, post.likes])

    useEffect(()=>{
        const getpost = async ()=>{
            const postData = await axiosInstance.get("users/"+post.userId, {headers: {authorization: 'Bearer '+user.accessToken}});
            console.log('From posts',postData.data);
            setPostUserName(postData.data)
        }
        getpost()
    }, [post.userId, user.accessToken])

    return (
            <div className="comment-thread">
            <details open className="comment" id="comment-1">
                <summary>
                    <div className="comment-heading">
                        <div className="comment-info">
                            <div className="post__uinfo-left">
                                <Link to={`/profile/${postUserName.username}`} state={{searchUsrId: post.userId}}>
                                    <img className="p-info-l-profileimg" 
                                    src={postUserName.avatar}
                                    alt="" />
                                </Link>
                            </div>
                            <Link to={`/profile/${postUserName.username}`} state={{searchUsrId: user.id}}>
                                <div className="main__thread-author">@{postUserName.username}</div>
                            </Link>
                            <p className="m-0">
                                <span className="m-0-likes">{like} like</span> &bull; {timeAgo(post.createdAt)}
                            </p>
                        </div>
                        {postUserName.username === user.user?(
                            <div className="post_del" onClick={clickPostDelete}> <MdDelete /> </div>
                        ):null}
                    </div>
                </summary>

                <div className="comment-body">
                    <p className="cb__mthread">
                        {post?.desc}
                    </p>
                    <button className="cb__btn" type="button" data-toggle="reply-form" data-target="comment-1-reply-form">
                        <BiCommentDots />
                    </button>
                    <button className="cb__btn" type="button" onClick={likeIncrHandler}>
                        <BiLike />
                    </button>

                    <form method="POST" className="reply-form d-none" id="comment-1-reply-form">
                        <textarea placeholder="Reply to comment" rows="4"></textarea>
                        <button type="submit">Submit</button>
                        <button type="button" data-toggle="reply-form" data-target="comment-1-reply-form">Cancel</button>
                    </form>
                </div>
            </details>
            
        </div>
  );
}
